import React, { useEffect, useRef } from 'react';
import { PricingPageLayout } from '../components/shared/PricingPageLayout';
import { PricingBenefitsContainer } from '../containers';
import { LegacyTiersProvider } from '../contexts';
import { PRICING_BENEFITS_PAGE_LOAD, newrelic } from '../utils/newrelic';
import { useRewardsAndOffers } from '../hooks';

const PricingBenefitsPage = () => {
  const {
    rewardsAndOffers = null,
    generalError = null,
    isLoading = true,
  } = useRewardsAndOffers();

  const hasLoggedEvent = useRef(false);

  useEffect(() => {
    if (isLoading || hasLoggedEvent.current) return;
    hasLoggedEvent.current = true;
    if (generalError) {
      newrelic.addPageAction(PRICING_BENEFITS_PAGE_LOAD, {
        result: 'error',
        errorMessage: generalError.message,
        pageType: 'legacy',
      });
      return;
    }
    newrelic.addPageAction(PRICING_BENEFITS_PAGE_LOAD, {
      result: 'success',
      pageType: 'legacy',
    });
  }, [isLoading, generalError, rewardsAndOffers]);

  return (
    <PricingPageLayout>
      <LegacyTiersProvider rewardsAndOffers={rewardsAndOffers}>
        <PricingBenefitsContainer />
      </LegacyTiersProvider>
    </PricingPageLayout>
  );
};

PricingBenefitsPage.displayName = 'PricingBenefitsPage';

export { PricingBenefitsPage };
